import React from 'react';
import './FilterPill.css';
import { AssetUrls } from 'config/assets';

interface FilterPillProps {
  label: string;
  active: boolean;
  onToggle: () => void;
}

const FilterPill: React.FC<FilterPillProps> = ({ label, active, onToggle }) => {
  return (
    <button className={`filter-pill ${active ? 'active' : ''}`} onClick={onToggle}>
      <span>{label}</span>
      {active && (
        <img
          src={AssetUrls.icons.dropdowns.close}
          alt="close"
          className="filter-pill-close"
        />
      )}
    </button>
  );
};

export default FilterPill;
